import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Box, Slide, useTheme } from "@mui/material";
import WifiOffRoundedIcon from "@mui/icons-material/WifiOffRounded";
import WifiRoundedIcon from "@mui/icons-material/WifiRounded";
import CustomTypography from "./form/CustomTypography";
import { networkStatusStore } from "../../../stores/NetworkStatusStore";

// Sits above drawers, dialogs and StepLoader's overlay.
const BANNER_Z_INDEX = 10000;

const NetworkStatusBanner = () => {
  const theme = useTheme();
  const { status, isVisible } = networkStatusStore;

  useEffect(() => {
    networkStatusStore.start();
  }, []);

  const isOffline = status === "offline";
  const background = isOffline
    ? theme.palette.error.main
    : theme.palette.customColors.successGreen;
  const textColor = theme.palette.customColors.white;
  const Icon = isOffline ? WifiOffRoundedIcon : WifiRoundedIcon;

  return (
    <Slide in={isVisible} direction="down" mountOnEnter unmountOnExit>
      <Box
        role="status"
        aria-live="polite"
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: BANNER_Z_INDEX,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
          py: 0.75,
          px: 2,
          backgroundColor: background,
          color: textColor,
          boxShadow: theme.shadows[3],
          transition: "background-color 0.3s ease",
        }}
      >
        <Icon sx={{ fontSize: 18, color: textColor }} />
        <CustomTypography variant="body2" color={textColor} fontWeight={600}>
          {isOffline
            ? "You're offline. Check your connection — we'll reconnect automatically."
            : "Back online"}
        </CustomTypography>
      </Box>
    </Slide>
  );
};

export default observer(NetworkStatusBanner);
